import { render, staticRenderFns } from "./basicInfoForm.vue?vue&type=template&id=336701f0&scoped=true"
import script from "./basicInfoForm.vue?vue&type=script&lang=js"
export * from "./basicInfoForm.vue?vue&type=script&lang=js"
import style0 from "./basicInfoForm.vue?vue&type=style&index=0&id=336701f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336701f0",
  null
  
)

export default component.exports